/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  linkTypeMap,
  createClient as createClientOriginal,
  generateGraphqlOperation,
  type FieldsSelection,
  type GraphqlOperation,
  type ClientOptions,
  GenqlError,
} from './graphql/runtime';
import { Fields } from './graphql/runtime/generateGraphqlOperation';
import { CompressedTypeMap } from './graphql/runtime/types';
import type {
  QueryGenqlSelection,
  Query,
  MutationGenqlSelection,
  Mutation,
  SubscriptionGenqlSelection,
  Subscription,
} from './graphql/schema';
export type { FieldsSelection } from './graphql/runtime';
export { GenqlError };
import types from './graphql/types';
export * from './graphql/schema';
const typeMap = linkTypeMap(types as unknown as CompressedTypeMap<number>);

export interface Client {
  query<R extends QueryGenqlSelection>(
    request: R & { __name?: string },
  ): Promise<FieldsSelection<Query, R>>;

  mutation<R extends MutationGenqlSelection>(
    request: R & { __name?: string },
  ): Promise<FieldsSelection<Mutation, R>>;
}

export const createClient = function (options?: ClientOptions): Client {
  return createClientOriginal({
    ...options,
    queryRoot: typeMap['Query']!,
    mutationRoot: typeMap['Mutation']!,
    subscriptionRoot: typeMap['Subscription']!,
  });
};

export const everything = {
  __scalar: true,
};

export type QueryResult<fields extends QueryGenqlSelection> = FieldsSelection<
  Query,
  fields
>;
export const generateQueryOp: (
  fields: QueryGenqlSelection & { __name?: string },
) => GraphqlOperation = function (fields) {
  return generateGraphqlOperation(
    'query',
    typeMap['Query']!,
    fields as unknown as Fields,
  );
};

export type MutationResult<fields extends MutationGenqlSelection> =
  FieldsSelection<Mutation, fields>;
export const generateMutationOp: (
  fields: MutationGenqlSelection & { __name?: string },
) => GraphqlOperation = function (fields) {
  return generateGraphqlOperation(
    'mutation',
    typeMap['Mutation']!,
    fields as unknown as Fields,
  );
};

export type SubscriptionResult<fields extends SubscriptionGenqlSelection> =
  FieldsSelection<Subscription, fields>;
export const generateSubscriptionOp: (
  fields: SubscriptionGenqlSelection & { __name?: string },
) => GraphqlOperation = function (fields) {
  return generateGraphqlOperation(
    'subscription',
    typeMap['Subscription']!,
    fields as unknown as Fields,
  );
};
